/* eslint-disable */
import $ from 'jquery';
import scrollTo from '@bingads-webui-static-legacy/extension/scrollTo';
export default {
  scrollTo: scrollTo
};

